export const capitalizeFirstLetter = (str: string) =>
  str.charAt(0).toUpperCase() + str.slice(1);

// get first two lines of text
export const getFirstTwoLines = (str: string) => {
  const lines = str.split('\n');
  return lines.slice(0, 2).join('\n');
};

export const isString = (value: any) => typeof value === 'string';

export const codeifyName = (name: string = '') =>
  name
    .toLowerCase()
    .replace(/ /g, '-')
    .replace(/&/g, 'and')
    .replace(/[^\w-]+/g, '');
